import React from 'react';

interface Props {
  type: string;
}

export default ({ type }: Props) => {
  return (
    <div className="tour__category-wrapper text-uppercase text-center font-weight-bold">
      <span className="tour__category d-inline-block">{type}</span>
    </div>
  );
};
